import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Replenishment } from '../models/replenishment.entity'

export type ReplenishmentNotificationCode =
  | GenericNotificationCode
  | 'CANNOT_CANCEL_MOVED_QTY'
  | 'REPLENISHMENT_CANCELED'
  | 'REPLENISHMENT_SAVED'
  | 'FILE_UPLOADED'
  | 'WRONG_STATUS'

export type ReplenishmentModalCode = 'REPLENISHMENT_CANCELATION'

/**
 * Parse goods return code to a notification
 * @param code - the goods return notification code
 * @returns the notification options
 */
export function parseReplenishmentNotification(
  code?: ReplenishmentNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'CANNOT_CANCEL_MOVED_QTY':
      return {
        message:
          'Cannot cancel replenishment with moved quantity greater than zero',
        color: 'error',
      }
    case 'REPLENISHMENT_CANCELED':
      return {
        message: 'Replenishment canceled successfully',
        color: 'success',
      }
    case 'REPLENISHMENT_SAVED':
      return {
        message: 'Replenishment saved successfully',
        color: 'success',
      }
    case 'WRONG_STATUS':
      return {
        message:
          'Only replenishments in PENDING and PROCESSING status can be canceled',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse goods return code to an modal
 * @param code - the goods return modal code
 * @param goodsReturn - the goods return object
 * @returns the modal settings
 */
export function parseReplenishmentModal(
  code: ReplenishmentModalCode,
  replenishment?: Replenishment,
): DialogOptions {
  switch (code) {
    case 'REPLENISHMENT_CANCELATION': {
      const rpNumber = replenishment?.replenishmentNumber
      return {
        title: 'Cancel replenishment',
        message:
          'You are about to cancel the replenishment <strong>%s</strong>. Proceed with cancelation?',
        messageParams: rpNumber ? [rpNumber] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
